import { defineTemplate } from '../../../../utils';
import { ESPN_HEROS_BASE_URL } from './urls';
import { ESPN_HEROS_OVERLAYS } from './overlays';
import { ESPN_HERO_LEAGUES } from './data/leagues';
import playerSkeletonOverlay from './data/player_skeleton_overlay.png';
import { espnHero1920x2400 } from './layouts/ESPNHero-1920x2400';
import { espnHero2000x2818 } from './layouts/ESPNHero-2000x2818';
import { espnHero3840x982 } from './layouts/ESPNHero-3840x982';
import { espnHero3840x1280 } from './layouts/ESPNHero-3840x1280';
import { espnHero3840x2160 } from './layouts/ESPNHero-3840x2160';

const ESPN_HEROS_DEMO = `${ESPN_HEROS_BASE_URL}/premier-league/demo`;

export const disneyEspnHero = defineTemplate({
  mode: 'wysiwyg',
  id: 'espn/espn-heros',
  clientId: 'DISNEY',
  handlerKey: 'DISNEY',
  title: 'ESPN Heros',
  templateFamily: 'espn-heros',
  thumbnail: {
    url: `${ESPN_HEROS_DEMO}/1920x2400.png`,
    optimizedUrl: `${ESPN_HEROS_DEMO}/optimized/1920x2400.png`,

    aspectRatio: 'vertical'
  },
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'league',
      label: 'Liga',
      type: 'visual-search-single',
      placeholder: 'Buscar liga...',
      slotLabel: 'Liga',
      required: true,
      options: ESPN_HERO_LEAGUES.map(league => ({
        value: league.value,
        label: league.label,
        disabled: league.disabled,
        imageUrl: league.imageUrl,
        backgroundColor: league.backgroundColor
      }))
    },
    {
      key: 'teams',
      label: 'Equipos',
      type: 'visual-search',
      placeholder: 'Buscar equipo...',
      slotLabels: ['Equipo 1', 'Equipo 2'],
      required: true,
      options: []
    },
    {
      key: 'players',
      label: 'Jugadores',
      type: 'grouped-image-selector',
      allowCustomInput: true,
      required: true,
      maxSelectionPerGroup: 2,
      loadSubImagesKey: 'espn-heros-players',
      tooltip: 'PNG transparente, 2048×2048px',
      tooltipImageLink: playerSkeletonOverlay
    },
    {
      key: 'backgrounds',
      label: 'Fondos',
      type: 'internal',
      required: false,
      hiddenFromDetail: true
    }
  ],
  canvasBinding: {
    resolutions: [
      {
        id: '1920x2400',
        label: '1920 × 2400',
        canvasWidth: 1920,
        canvasHeight: 2400,
        type: 'image',
        layout: espnHero1920x2400,
        aspectRatioCode: 'P80',
        overlays: ESPN_HEROS_OVERLAYS['1920x2400']
      },
      {
        id: '2000x2818',
        label: '2000 × 2818',
        canvasWidth: 2000,
        canvasHeight: 2818,
        type: 'image',
        layout: espnHero2000x2818,
        aspectRatioCode: 'P80',
        overlays: ESPN_HEROS_OVERLAYS['2000x2818']
      },
      {
        id: '3840x982',
        label: '3840 × 982',
        canvasWidth: 3840,
        canvasHeight: 982,
        type: 'image',
        layout: espnHero3840x982,
        aspectRatioCode: 'L391',
        overlays: ESPN_HEROS_OVERLAYS['3840x982']
      },
      {
        id: '3840x1280',
        label: '3840 × 1280',
        canvasWidth: 3840,
        canvasHeight: 1280,
        type: 'image',
        layout: espnHero3840x1280,
        aspectRatioCode: 'L30',
        overlays: ESPN_HEROS_OVERLAYS['3840x1280']
      },
      {
        id: '3840x2160',
        label: '3840 × 2160',
        canvasWidth: 3840,
        canvasHeight: 2160,
        type: 'image',
        layout: espnHero3840x2160,
        aspectRatioCode: 'L178',
        overlays: ESPN_HEROS_OVERLAYS['3840x2160']
      }
    ],
    fieldBindings: [
      // Replaces each player slot's image; valuePath points to the URL in each player object.
      {
        kind: 'array',
        fieldKey: 'players',
        pieceIdPattern: 'player-{index}',
        maxSlots: 4,
        bindingType: 'image-replace',
        valuePath: 'subImage'
      },
      {
        kind: 'simple',
        fieldKey: 'backgrounds',
        pieceId: 'background',
        bindingType: 'image-replace'
      }
    ]
  }
});
